import React, { useState, useEffect } from "react";
import "./AddItemListComponent.css";
import TextField from "@material-ui/core/TextField";
import ScannerComponent from "../../BarcodeScanner/ScannerComponent";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

import AppBar from "@material-ui/core/AppBar";
import { Button } from "react-bootstrap";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";

import displayDate from "../../../Utilities/displayDate";

export default function AddItemListComponent(props) {
  const [name, setName] = useState("");
  const [qty, setQty] = useState(1);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [visibleError, setVisibleError] = useState("none");
  const [scanning, setScanning] = useState(false);
  const [EAN, setEAN] = useState("");
  const [fullName, setFullName] = useState("");
  const [water_fp, setWater_fp] = useState("");
  const [carbon_fp, setCarbon_fp] = useState("");
  const [nutrients, setNutrients] = useState("");
  const [average_price, setAverage_price] = useState("");
  const [reset, setReset] = useState(true);
  const [image, setImage] = useState("");
  const [scanDialog, setScanDialog] = useState(false);
  const [visibleScanError, setVisibleScanError] = useState("none");
  const [addedSnackbar, setAddedSnackbar] = useState(false);

  let date = new Date();
  let langData = require("../../../Data/language.json");

  const onAddClick = () => {
    if (name.length === 13 && !isNaN(name) && qty >= 1) {
      executeEANFetch(name);
      setScannedResults();
      emptyFields();
    } else if (name !== "" && qty >= 1) {
      props.onAdd(
        props.user,
        name,
        comment,
        qty,
        EAN,
        fullName,
        "",
        "",
        "",
        "",
        "",
        "",
        image,
        carbon_fp,
        water_fp,
        nutrients,
        average_price
      );
      emptyFields();
    } else if (name === "") {
      setVisibleError("block");
      setError(langData[props.language].list.errors.name);
    } else if (qty < 1) {
      setVisibleError("block");
      setError(langData[props.language].list.errors.quantity);
    }
  };

  const emptyFields = () => {
    setName("");
    setQty(1);
    setComment("");
    setEAN("");
    setFullName("");
    setImage("");
    setCarbon_fp("");
    setWater_fp("");
    setNutrients("");
    setAverage_price("");
  };

  const onScanClick = () => {
    if (!scanning) {
      props.clearFetchedItem();
    }
    setReset(false);
    setScanning(!scanning);
  };

  const setScannedResults = () => {
    if (props.fetchedItem.succesfulFetch) {
      try {
        let EAN = props.fetchedItem.gtin.slice(1);
        let name = props.fetchedItem.name;
        let fullName = props.fetchedItem.fullname;
        let size = props.fetchedItem.size;
        let unit_id = props.fetchedItem.unit_id;
        let comment = "";
        let qty = 1;
        let dep_id = props.fetchedItem.department_id;
        let dep_name = props.fetchedItem.department_name;
        let cat_id = props.fetchedItem.category_id;
        let cat_name = props.fetchedItem.category_name;
        let subcat_id = props.fetchedItem.subcategory_id;
        let subcat_name = props.fetchedItem.subcategory_name;
        let carbon_fp = props.fetchedItem.carbonfootprint;
        let water_fp = props.fetchedItem.waterfootprint;
        let nutrients = props.fetchedItem.nutrients;
        let average_price = props.fetchedItem.average_price;
        let image = props.fetchedItem.image;
        props.onAdd(
          props.user,
          name,
          comment,
          qty,
          EAN,
          fullName,
          size,
          unit_id,
          dep_id,
          dep_name,
          cat_id,
          cat_name,
          subcat_id,
          subcat_name,
          image,
          carbon_fp,
          water_fp,
          nutrients,
          average_price
        );
        setAddedSnackbar(true);
        setError("");
        setVisibleError("none");
        emptyFields();
      } catch {
        setError(langData[props.language].scanner.notFound);
      }
    }
  };

  const executeEANFetch = (EAN) => {
    setEAN(EAN);
    props.fetchEAN(EAN);
  };

  const handleScanHelpOpen = () => {
    setScanDialog(true);
  };

  const handleScanHelpClose = (value) => {
    setScanDialog(false);
  };

  useEffect(() => {
    if (name !== "" && qty > 0) {
      setError("");
      setVisibleError("none");
      setVisibleScanError("none");
    }
  }, [qty, name]);

  // CALLED WHEN API RETURNS EITHER COMPLETE FETCHED ITEM OR ERROR ITEM {message: "not found"}
  useEffect(() => {
    if (!reset) {
      if (!props.fetchedItem.succesfulFetch) {
        emptyFields();
        setVisibleError("block");
        setError(EAN + " " + langData[props.language].scanner.notFound);
        setVisibleScanError("block");
        setError(langData[props.language].scanner.noData + EAN);
      } else if (props.fetchedItem.succesfulFetch) {
        setScannedResults();
      }
    }
  }, [props.fetchedItem]);

  return (
    <div className="container-fluid addItemCont">
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={addedSnackbar}
        autoHideDuration={3000}
        onClose={() => setAddedSnackbar(false)}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={
          <span id="message-id">
            Added:{" "}
            {props.fetchedItem !== undefined ? props.fetchedItem.name : ""}
          </span>
        }
      ></Snackbar>
      <div className="row" style={{ height: 59 }}>
        <div className="container col-5 listCell">
          <TextField
            required
            id="outlined-name-input"
            onChange={(e) => setName(e.target.value)}
            type="name"
            name="name"
            margin="normal"
            value={name}
            variant="standard"
            placeholder={langData[props.language].addItem.placeholder}
          />
        </div>
        <div className="container col-1 listCell">
          <TextField
            id="outlined-qty-input"
            inputProps={{ min: "1", max: "20", step: "1" }}
            onChange={(e) => setQty(e.target.value)}
            type="number"
            name="quantity"
            margin="normal"
            value={qty}
            variant="standard"
            style={{ width: 30 }}
          />
        </div>
        <div
          className="container col-2"
          style={{ paddingLeft: "2px", paddingRight: "2px" }}
        >
          <p className="date">{displayDate(date)}</p>
        </div>
        <div className="container listBtn col-2 d-none d-sm-block">
          <TextField
            id="outlined-comment-input"
            onChange={(e) => setComment(e.target.value)}
            type="comment"
            name="comment"
            value={comment}
            margin="normal"
            variant="standard"
          />
        </div>
        <div className="container inputField col-2">
          <div className="row">
            {scanning ? (
              <div className="container-fluid scanLoader">
                <div className="orangeScanSpinner" />
              </div>
            ) : (
              <Button
                id="scanBtn"
                onClick={() => {
                  onScanClick();
                }}
              >
                <img
                  className="scanIcon"
                  src={require("../../../Images/Icons/cameraIcon.svg")}
                  alt="scanIcon"
                ></img>
              </Button>
            )}
            <Button
              id="listItemButton"
              onClick={() => {
                onAddClick();
              }}
            >
              <img
                className="plusIcon"
                src={require("../../../Images/Icons/plus.svg")}
                alt="plusIcon"
              />
            </Button>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="addItemErrBox" style={{ display: visibleError }}>
          <div className="row">
            <p className="addItemErrText">{error}</p>
            <img
              style={{ display: visibleScanError }}
              onClick={() => handleScanHelpOpen()}
              className="helpIcon"
              src={require("../../../Images/Icons/helpIcon.svg")}
              alt="helpIcon"
            />
            <Dialog
              onClose={() => handleScanHelpClose()}
              aria-labelledby="dialogTitle"
              open={scanDialog}
            >
              <DialogTitle style={{ textAlign: "center" }} id="dialogTitle">
                {langData[props.language].dialogs.scanHelp.title}
              </DialogTitle>
              <div className="container-fluid scanHelpContainer">
                <hr />
                <p className="scanHelpTitle">
                  {langData[props.language].dialogs.scanHelp.options}
                </p>
                <p className="scanHelpSubTitle">
                  {langData[props.language].dialogs.scanHelp.noDataTitle}
                </p>
                <p className="scanHelpText">
                  {langData[props.language].dialogs.scanHelp.noData}
                </p>
                <p className="scanHelpSubTitle">
                  {langData[props.language].dialogs.scanHelp.badConditionsTitle}
                </p>
                <p className="scanHelpText">
                  {langData[props.language].dialogs.scanHelp.badConditions}
                </p>
              </div>
              <div style={{ textAlign: "center" }} className="dialogBtnWrapper">
                <Button
                  className="closeDialogBtn"
                  onClick={() => handleScanHelpClose()}
                >
                  {langData[props.language].dialogs.scanHelp.back}
                </Button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <Dialog fullScreen open={scanning} onClick={() => setScanning(false)}>
          <AppBar>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setScanning(false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <h6>{langData[props.language].scanner.dialogTitle}</h6>
            </Toolbar>
          </AppBar>
          <ScannerComponent
            scanningStatus={scanning}
            fetchingStatus={props.fetchingStatus}
            fetchedItem={props.fetchedItem}
            fetchEAN={(EAN) => executeEANFetch(EAN)}
            stopScan={() => onScanClick()}
            setVisibleError={setVisibleError}
            language={props.language}
          />
        </Dialog>
      </div>
    </div>
  );
}
